import FieldText from "components/FieldText";
import { Button } from "react-bootstrap";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";

const Equipments = ({ name, control, setValue, watch, newValueName }) => {
  const { t } = useTranslation();
  const { fields, append, remove } = useFieldArray({
    control,
    name: name,
  });

  const newEqValue = watch(newValueName);

  const addEquipment = () => {
    if (newEqValue.trim() !== "") {
      // Check if the eq is not empty
      append({ value: newEqValue.trim() }); // Append the string value of the eq
      setValue(newValueName, ""); // Clear the input field
    }
  };

  return (
    <div className="col-12 border p-4 mt-4">
      <h2>{t(name)}</h2>
      <div className="mt-4">
        <FieldText required name={newValueName} placeholder={name} control={control} style={{ flex: 1 }} />
        <Button className="d-flex align-items-center mt-2 ml-auto" size="sm" onClick={addEquipment} disabled={!newEqValue}>
          <div className="gallery-add-title">{t("add")}</div>
          <div className="ml-1">+</div>
        </Button>
      </div>
      <div className="mt-5 col-12 d-flex">
        {fields.map((eq, index) => (
          <div className="d-flex ">
            <span className="badge badge-light d-flex mr-2 align-items-center text-dark" style={{ fontSize: "1rem" }}>
              {eq.value}
              <button type="button" className="close ml-2" aria-label="Dismiss" onClick={() => remove(index)}>
                <span aria-hidden="true">&times;</span>
              </button>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Equipments;
